module.exports = __webpack_public_path__ + "static/media/YM62_0.252ec11f.jpg";